'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var validate = require('validate.js');
function InterlineFaresAdjustmentGridController($scope, dataRetrieverService, dataRetrieverConstantsService, dataService, csvService) {
  var emptyErrorMessage = 'can not be empty';
  var commaSeparatedErrorMessage = 'values must be comma separated alphabetic string';
  var minimumLength = function minimumLength(length) {
    return validate.format('should be at least %{length} characters', {
      length: length
    });
  };
  var constraints = {
    partnerAirline: {
      presence: {
        allowEmpty: false,
        message: errorMessageFormat('Partner Carrier', emptyErrorMessage)
      },
      length: {
        is: 2,
        wrongLength: errorMessageFormat('Partner Carrier', minimumLength(2))
      },
      type: 'string'
    },
    partnerSegment: {
      presence: {
        allowEmpty: false,
        message: errorMessageFormat('Partner Segment', emptyErrorMessage)
      },
      length: {
        minimum: 6,
        tooShort: errorMessageFormat('Partner Segment', minimumLength(6))
      },
      type: 'string'
    },
    fareAdjustment: {
      presence: {
        message: errorMessageFormat('Fare Ajustment', emptyErrorMessage)
      },
      type: 'number'
    },
    trueOD: {
      presence: false,
      length: function length(value) {
        if (!_.size(value)) {
          return false;
        }
        return {
          minimum: 6,
          tooShort: errorMessageFormat('True OD', minimumLength(6))
        };
      },
      type: 'string'
    },
    classNames: {
      presence: false,
      type: 'string',
      format: {
        pattern: '^([A-Za-z]+,?\\s*)*$',
        message: errorMessageFormat('Class Names', commaSeparatedErrorMessage)
      }
    },
    adjustmentType: {
      presence: {
        message: errorMessageFormat('Adjust Type', emptyErrorMessage)
      },
      inclusion: ['A', 'P']
    }
  };
  function errorMessageFormat(attributeName, message) {
    return function () {
      return validate.format('^%{name} %{message}.', {
        name: attributeName,
        message: message
      });
    };
  }
  $scope.gridId = 'interline-fares-adjustment';
  dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.FARES_SCREEN, dataRetrieverConstantsService.FARES_INTERLINE_FARES_ADJUSTMENT).setCustomSearchCriteriaRules([]);
  $scope.refresh = function () {
    $scope.$broadcast('grid:clearAndLoadData:' + $scope.gridId);
  };
  $scope.customSave = function (editRows) {
    return dataService.save(editRows).then($scope.refresh);
  };
  $scope.customSaveErrorMessage = function (response) {
    if (response.status === 409) {
      toastr.error('Could not save duplicate documents.');
    } else {
      toastr.error('Can not able to save the current document.');
    }
  };
  function validateFields(row) {
    var validations = validate(row, constraints);
    _.each(validations, function (errors) {
      $scope.errorMessage = _.concat($scope.errorMessage, errors);
    });
    return !_.size(validations);
  }
  $scope.customSaveValidation = function (editRows, allRows) {
    var filteredRows = _.filter(allRows, function (row) {
      return !row.isNewlyAdded || !_.isEmpty(row._original);
    });
    var filteredEditedRows = _.map(editRows, function (row, index) {
      row.editedRowId = index;
      return row;
    });
    filteredRows = _.concat(filteredEditedRows, filteredRows);
    var hashMaps = generateHashmaps(filteredRows);
    var classesMap = generateClassesTable(filteredRows);
    $scope.errorMessage = [];
    return _.reduce(editRows, function (isValid, row, editedRowIndex) {
      return isValid && validateFields(row) && !isDuplicated(row, hashMaps, editedRowIndex) && !isDuplicatedClasses(row, classesMap, editedRowIndex);
    }, true);
  };
  function generateClassesTable(allRows) {
    return _.chain(allRows).groupBy(function (row) {
      var sanitizedPartnerAdjustment = dataService.sanitizePartnerAdjustment(_.clone(row));
      return dataService.getGroupKey(sanitizedPartnerAdjustment);
    }).reduce(function (acc, partnerAdjustments, groupKey) {
      var classes = _.map(partnerAdjustments, function (item) {
        return {
          classNames: _.replace(item.classNames, /\s+/ig, ''),
          editedRowId: item.editedRowId
        };
      });
      acc[groupKey] = classes;
      return acc;
    }, {}).value();
  }
  function generateHashmaps(allRows) {
    return _.chain(allRows).map(function (partnerAdjustment) {
      return {
        hash: partnerAdjustment.hash,
        editedRowId: partnerAdjustment.editedRowId
      };
    }).value();
  }
  function isDuplicatedClasses(partnerAdjustment, classesMap, editedRowId) {
    if (!partnerAdjustment.isNewlyAdded) {
      return false;
    }
    var sanitizedPartnerAdjustment = dataService.sanitizePartnerAdjustment(_.clone(partnerAdjustment));
    var currentGroupKey = dataService.getGroupKey(sanitizedPartnerAdjustment);
    var currentClasses = sanitizedPartnerAdjustment.classNames;
    var group = classesMap[currentGroupKey];
    if (!_.size(group) || !_.size(currentClasses)) {
      return false;
    }
    var groupClasses = _.chain(group).filter(function (item) {
      return item.editedRowId !== editedRowId;
    }).map(function (item) {
      return item.classNames;
    }).join(',').value();
    var intersectedClasses = _.intersection((groupClasses || '').split(','), (currentClasses || '').split(','));
    var isDuplicated = _.size(intersectedClasses) > 0;
    if (isDuplicated) {
      var classes = intersectedClasses.join(',');
      var message = _.size(intersectedClasses) === 1 ? 'class ' + classes + ' already used in another row.' : 'classes ' + classes + ' already used in another row.';
      $scope.errorMessage.push(message);
    }
    return isDuplicated;
  }
  function isDuplicated(partnerAdjustment, hashedRows, editedRowId) {
    var hash = dataService.hashPartnerAdjustmentKey(dataService.sanitizePartnerAdjustment(_.clone(partnerAdjustment)));
    var isDuplicated = _.find(hashedRows, function (row) {
      if (!partnerAdjustment.isNewlyAdded) {
        return false;
      }
      return row.hash === hash && row.editedRowId !== editedRowId;
    });
    if (isDuplicated) {
      $scope.errorMessage.push('Duplicated Row please change de value');
    }
    return isDuplicated;
  }
  $scope.customErrorMessage = function () {
    if (!_.size($scope.errorMessage)) {
      return;
    }
    return $scope.errorMessage.join('<br>');
  };
  $scope.customRemove = function (editRows) {
    return dataService.remove(editRows).then($scope.refresh);
  };
  $scope.makeExportToCsv = function (visibleRows) {
    csvService.exportToCSV(visibleRows);
  };
}
InterlineFaresAdjustmentGridController.$inject = ['$scope', 'DataRetrieverService', 'DataRetrieverConstantsService', 'InterlineFaresAdjustmentGridService', 'InterlineFaresAdjustmentCSVService'];
module.exports = InterlineFaresAdjustmentGridController;